module.exports = __webpack_public_path__ + "static/media/keyPartners.1f32d794.svg";